(function () {
  <!-- nav-hover-image -->
  var MENU_CONFIG = [{"label":"Skate","defaultImage":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/dr-deck-logo.png?v=1776213794","subMenus":[{"label":"Decks","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/decks-plateaux.png"},{"label":"Complètes Skate","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/compl-tes-skate_a559be62-23d5-4890-aaa8-e213234bb5d8.png"},{"label":"Roues Skate","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/roues.png"},{"label":"Trucks Skate","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/trucks.png"},{"label":"Roulements Skate","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/roulements-skate.png"},{"label":"Grip Tape","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/grip-tape.png"}]},{"label":"Accessoires","defaultImage":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/outils-entretien.png","subMenus":[{"label":"Outils & Entretien","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/outils-entretien.png"},{"label":"Sacs & Backpacks","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/sacs-backpacks_00d410aa-1bb1-4bac-a3c0-c4d33a2327aa.png"},{"label":"Casques & Protections","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/casques-protections.png"},{"label":"Accessoires","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/outils-entretien.png"}]},{"label":"Textile","defaultImage":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/hoodies-sweats.png","subMenus":[{"label":"T-shirts","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/t-shirts_dcaf4605-9219-4bd8-be3b-a8e789fee406.png"},{"label":"Hoodies & Sweats","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/hoodies-sweats.png"},{"label":"Pantalons & Shorts","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/pantalons-shorts.png"},{"label":"Chaussettes & Bonnets","image":"https://cdn.shopify.com/s/files/1/1014/0427/9132/files/chaussettes-bonnets_589577fe-fd7b-40c5-91f1-583a0c68846e.png"}]}];

  function normalize(str) {
    return str.trim().toLowerCase();
  }

  function buildImageContainer(defaultSrc) {
    var container = document.createElement('div');
    container.className = 'nav-hover-image-container';
    var img = document.createElement('img');
    img.className = 'nav-hover-image-img';
    img.src = defaultSrc;
    img.alt = '';
    container.appendChild(img);
    return container;
  }

  function setupMenu(menuConfig) {
    // Find the main menu trigger by text content
    var triggers = document.querySelectorAll(
      'header-component .header__nav a, header-component .header__nav button, header-component .header__nav summary, header-component .header__nav [data-menu-item]'
    );
    var trigger = null;
    for (var i = 0; i < triggers.length; i++) {
      var el = triggers[i];
      var text = (el.textContent || '').trim();
      if (normalize(text) === normalize(menuConfig.label)) {
        trigger = el;
        break;
      }
    }

    // Also try broader selectors for the Balance theme
    if (!trigger) {
      var allLinks = document.querySelectorAll('header-component a, header-component summary, header-component button');
      for (var j = 0; j < allLinks.length; j++) {
        var linkEl = allLinks[j];
        // Only direct text, not children
        var directText = '';
        for (var k = 0; k < linkEl.childNodes.length; k++) {
          if (linkEl.childNodes[k].nodeType === Node.TEXT_NODE) {
            directText += linkEl.childNodes[k].textContent;
          }
        }
        if (normalize(directText) === normalize(menuConfig.label)) {
          trigger = linkEl;
          break;
        }
      }
    }

    if (!trigger) return;

    // Find the dropdown panel: look for a sibling or parent's sibling that is a dropdown
    var panel = null;
    var parent = trigger.closest('details, li, .header__nav-item, [data-menu]');
    if (parent) {
      panel = parent.querySelector('ul, .header__submenu, .mega-menu, [data-submenu], details > div, details > ul');
      if (!panel) {
        // Try next sibling
        var sibling = parent.nextElementSibling;
        if (sibling && (sibling.tagName === 'UL' || sibling.classList.contains('header__submenu'))) {
          panel = sibling;
        }
      }
    }

    // Fallback: look for a details element containing the trigger
    if (!panel) {
      var detailsEl = trigger.closest('details');
      if (detailsEl) {
        panel = detailsEl.querySelector('ul, div.mega-menu__content, div[class*="submenu"], div[class*="dropdown"]');
      }
    }

    if (!panel) return;

    // Avoid double-injection
    if (panel.querySelector('.nav-hover-image-container')) return;

    var container = buildImageContainer(menuConfig.defaultImage);
    panel.insertBefore(container, panel.firstChild);

    var img = container.querySelector('.nav-hover-image-img');

    function setImage(src) {
      img.style.opacity = '0';
      setTimeout(function () {
        img.src = src;
        img.style.opacity = '1';
      }, 120);
    }

    // Hover on main trigger → show default
    trigger.addEventListener('mouseenter', function () {
      setImage(menuConfig.defaultImage);
    });

    // Hover on sub-menu links → swap image
    var subLinks = panel.querySelectorAll('a, li');
    for (var s = 0; s < subLinks.length; s++) {
      (function (subEl) {
        subEl.addEventListener('mouseenter', function () {
          var text = (subEl.textContent || '').trim();
          var match = null;
          for (var m = 0; m < menuConfig.subMenus.length; m++) {
            if (normalize(text) === normalize(menuConfig.subMenus[m].label)) {
              match = menuConfig.subMenus[m];
              break;
            }
          }
          if (match) {
            setImage(match.image);
          }
        });
      })(subLinks[s]);
    }

    // Mouse leave panel → revert to default
    panel.addEventListener('mouseleave', function () {
      setImage(menuConfig.defaultImage);
    });
  }

  function init() {
    MENU_CONFIG.forEach(function (menuConfig) {
      setupMenu(menuConfig);
    });
  }

  var attempts = 0;
  var maxAttempts = 20;

  function tryInit() {
    var header = document.querySelector('header-component');
    if (header) {
      init();
    } else if (attempts < maxAttempts) {
      attempts++;
      setTimeout(tryInit, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  // MutationObserver for dynamically rendered nav
  var observer = new MutationObserver(function () {
    var containers = document.querySelectorAll('.nav-hover-image-container');
    if (containers.length < 3) {
      init();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
